import * as ACTION_TYPES from '../constants/ACTION_TYPES';
import { get, differenceWith, isEqual, uniq } from 'lodash';

const defaultState: CartState = {
  items: {},
  isFetching: false,
};

export const getCartItems = (state: CartState) => {
  const items: Number[] = [];
  for (let key in state.items) {
    items.push(...state.items[key]);
  }
  return items;
};

export const getCartItemsByKey = (state: CartState) => (key: string) =>
  get(state.items, key, []);

export const getCartItemCount = (state: CartState) =>
  getCartItems(state).length;

function handleAddToCart(state: CartState, action: AddToCartAction): CartState {
  let items = state.items[action.payload.key];
  if (items) {
    items = [...items, ...action.payload.items.map(x => x.id)];
  } else {
    items = [...action.payload.items.map(x => x.id)];
  }
  return {
    ...state,
    items: {
      ...state.items,
      [action.payload.key]: uniq(items),
    },
  };
}

function handleRemoveFromCart(
  state: CartState,
  action: RemoveFromCartAction
): CartState {
  return {
    ...state,
    items: {
      ...state.items,
      [action.payload.key]: differenceWith(
        state.items[action.payload.key],
        action.payload.items.map(x => x.id),
        isEqual
      ),
    },
  };
}

function handleUpdateIsFetchingCart(
  state: CartState,
  action: UpdateIsFetchingCartAction
): CartState {
  const { isFetching } = action.payload;
  return {
    ...state,
    isFetching,
  };
}

export default function cart(
  state: CartState = defaultState,
  action: Action
): CartState {
  switch (action.type) {
    case ACTION_TYPES.ADD_TO_CART:
      return handleAddToCart(state, action as AddToCartAction);
    case ACTION_TYPES.REMOVE_FROM_CART:
      return handleRemoveFromCart(state, action as RemoveFromCartAction);
    case ACTION_TYPES.UPDATE_CART_IS_FETCHING:
      return handleUpdateIsFetchingCart(
        state,
        action as UpdateIsFetchingCartAction
      );
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/cart.ts